module.exports = __webpack_public_path__ + "static/media/medium-svgrepo-com.c1e21fcc.svg";